import React from "react";
import classnames from 'classnames';
import Switch from "react-switch";
import "./TwoLabelSwitch.scss";

export function TwoLabelSwitch({
  labelBefore,
  labelAfter,
  disabled,
  ...props
}) {
  return (
    <label className={classnames('TwoLabelSwitch', { 'TwoLabelSwitch_disabled': disabled })}>
      <span className="TwoLabelSwitch__label">{labelBefore}</span>
      <Switch
        disabled={disabled}
        width={72}
        height={34}
        handleDiameter={28}
        checkedIcon={false}
        uncheckedIcon={false}
        onColor={disabled ? '#303a49' : '#4c64a2'}
        offColor={disabled ? '#303a49' : '#4c64a2'}
        onHandleColor={disabled ? '#435065' : '#fff'}
        offHandleColor={disabled ? '#435065' : '#fff'}
        className="TwoLabelSwitch__switch"
        {...props}
      />
      <span className="TwoLabelSwitch__label">{labelAfter}</span>
    </label>
  )
}
